module.exports = __webpack_public_path__ + "static/img/beijing.091100a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beijing.png
// module id = TP5V
// module chunks = 26